// Shared color constants for task status and priority across the application

export const STATUS_COLORS = {
  pending: 'default',
  in_progress: 'info',
  completed: 'success',
  blocked: 'error',
  cancelled: 'warning',
} as const;

export const PRIORITY_COLORS = {
  high: 'default',
  medium: 'default',
  low: 'default',
} as const;

// Helper function to get status display text
export const getStatusDisplay = (status: string): string => {
  const statusMap: Record<string, string> = {
    pending: 'Pending',
    in_progress: 'In Progress',
    completed: 'Completed',
    blocked: 'Blocked',
    cancelled: 'Cancelled',
  };
  return statusMap[status] || status;
};

// Helper function to get priority display text
export const getPriorityDisplay = (priority: string): string => {
  const priorityMap: Record<string, string> = {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
  };
  return priorityMap[priority] || priority;
};
